var _path, _g, _g2, _g3, _path2, _path3, _g4, _g5, _g6, _g7, _g8, _g9, _g0, _g1, _g10, _g11, _g12, _g13, _g14, _g15, _g16;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFiji(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    enableBackground: "new 0 0 512 512",
    viewBox: "0 0 512 512",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m512 256c0 141.384-114.616 256-256 256s-256-114.616-256-256c0 .061 256-255.972 256-256 141.384 0 256 114.616 256 256z",
    fill: "#338af3"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#0052b4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m256 122.435v86.343l-89.043-86.343z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m133.565 256h75.212l-75.212-100.174-11.13 77.913z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    fill: "#f0f0f0"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m256 0c-.016 0-.029 0-.043 0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m255.315 256h.685c0-.23 0-.454 0-.685-.228.229-.456.457-.685.685z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m256 133.565c0-45.045 0-74.56 0-133.565h-.043c-141.365.024-255.957 114.629-255.957 256h133.565v-75.211l75.212 75.211h46.54c.228-.228.456-.456.685-.685 0-17.247 0-32.636 0-46.537l-75.214-75.213z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    fill: "#d80027"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m129.515 33.391c-40.039 22.799-73.325 56.085-96.124 96.124v126.485h66.783v-155.824-.002h155.826c0-21.063 0-41.129 0-66.783z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m256 224.519-90.953-90.953h-31.481v.002l122.432 122.432h.002s0-21.707 0-31.481z"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m289.391 166.957v89.042c0 59.64 77.913 77.914 77.913 77.914s77.913-18.274 77.913-77.914v-89.042l-77.913-22.261z",
    fill: "#f3f3f3"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m445.217 166.957v-33.391h-155.826v33.391h66.781v66.784h-66.781v22.259.002l66.781.001v74.497c6.718 2.376 11.132 3.414 11.132 3.414s4.412-1.036 11.129-3.414v-74.498h66.784v-.002-22.26h-66.784v-66.784h66.784z",
    fill: "#d80027"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g0 || (_g0 = /*#__PURE__*/React.createElement("g", null)), _g1 || (_g1 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", null)));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFiji);
export default __webpack_public_path__ + "static/media/fiji.7edf5da3533ba7d46a9ead79673c4d72.svg";
export { ForwardRef as ReactComponent };